export default __webpack_public_path__ + "static/media/reach-goals.d2f27d27.png";